import { setOptions, bootstrap } from 'vue-gtag'

export const topLevelPageMixin = {
  data() {
    return {
      trackerLoaded: false
    }
  },
  methods: {
    getSlugFromHost() {
      /* eslint-disable */
      //let hostname=window.location.hostname.split('.')[0]
      let hostname = window.location.hostname.split('-stg')[0].split('.')[0]
      return hostname
        .toString()
        .toLowerCase()
        .replace(/[0-9]/g, '') // Remove numbers
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    },
    addCSS(filename) {
      var head = document.getElementsByTagName('head')[0]
      var style = document.createElement('link')
      style.href = filename
      style.type = 'text/css'
      style.rel = 'stylesheet'
      head.append(style)
    },
    retrieveWebname() {
      // webname is a prop in the component inherint the mixin
      if (this.webname.length < 1) {
        this.webnamefinal = this.getSlugFromHost()
        if (this.webnamefinal.length < 3) {
          //pongo 3 por precaucion webname no puede ser menor de 3 para ser correcto
          this.webnamefinal = 'reserva_slots_exp' //this.$store.state.decoupled.webname // default state usually ''
        }
      } else this.webnamefinal = this.webname
      this.$store.commit('decoupled/setWebname', this.webnamefinal)
      // Here webname should already exist... otherwise
      if (this.webnamefinal.length < 3) {
        this.$buefy.toast.open({
          duration: 8000,
          message: 'Error loading config file:' + this.webnamefinal,
          type: 'is-danger'
        })
      }
    },
    retrieveConfigFilesAndInit() {
      if (this.$store.getters['decoupled/isInit'] === false) {
        this.retrieveWebname()
        this.$store.commit('decoupled/setServerEnv', this.env)

        let promiseConfigfile = this.$store.dispatch(
          'decoupled/getConfigFile',
          { slug: this.webnamefinal, force: false }
        )
        promiseConfigfile.finally(() => {
          this.addCSS(process.env.BASE_URL + this.webnamefinal + '/site.css')
          this.isLoading = false
          document.title = this._.get(
            this.$store.state.decoupled.configFile.texts,
            'general.productname',
            'Navandu Register & Login'
          )
          // init google tracker
          this.enableTracker()
          // document.title = this.$store.state.decoupled.configFile.texts.general.productName
        })

        return promiseConfigfile
      } else {
        this.isLoading = false
        this.webnamefinal = this.$store.state.decoupled.webname
        this.addCSS(process.env.BASE_URL + this.webnamefinal + '/site.css')
        this.trackPageView()
        return Promise.resolve('init')
        
      }
    },
    enableTracker(productName) {
      if (
        this.$store.state.decoupled.configFile.config[this.env].google_tracker
      ) {
        //only enable tracker if there is a id on the config file
        setOptions({
          config: {
            id: this.$store.state.decoupled.configFile.config[this.env]
              .google_tracker,
            params: {
              send_page_view: false
            }
          }
        })
        bootstrap(gtag).then(() => {
          this.trackerLoaded = true
          this.trackPageView()
        })
      }
    },
    trackPageView() {
      console.log('trackPageView' + this.$route.name)
      this.$gtag.pageview({
        page_path: this.$route.name
      })
    }
  }
}